import { useEffect, useRef, useState } from 'react';

const COMPACT_ENTER_PX = 24;
const COMPACT_EXIT_PX = 4;

/**
 * Tracks whether the scrollable content behind the floating header has been scrolled past its top,
 * so the header can collapse into a compact state. Re-attaches the scroll listener whenever `resetOn` changes,
 * since the scrollable element is re-rendered when the report data loads.
 */
export const useHeaderCompactOnScroll = (resetOn: unknown) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const contentEl = contentRef.current;
    if (!contentEl) {
      return;
    }
    const handleScroll = () => {
      const { scrollTop } = contentEl;
      setIsCompact((prev) => {
        if (!prev && scrollTop > COMPACT_ENTER_PX) {
          return true;
        }
        if (prev && scrollTop < COMPACT_EXIT_PX) {
          return false;
        }
        return prev;
      });
    };
    handleScroll();
    contentEl.addEventListener('scroll', handleScroll, { passive: true });
    return () => contentEl.removeEventListener('scroll', handleScroll);
  }, [resetOn]);

  return { contentRef, isCompact };
};
